import * as Pages from 'pages';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { constants } from 'utils';

export default function Routes() {
  return (
    <Switch>
      <Redirect exact from={constants.Routes.Root} to={constants.Routes.Home} />
      <Route exact path={constants.Routes.Home}>
        <Pages.Home />
      </Route>
      <Route exact path={constants.Routes.Transaction}>
        <Pages.Transaction />
      </Route>
      <Route exact path={constants.Routes.TechnicalError}>
        <Pages.TechnicalError />
      </Route>
      <Route exact path={constants.Routes.QuotaExceeded}>
        <Pages.QuotaExceeded />
      </Route>
      <Route path={constants.Routes.Others}>
        <Pages.NoMatch />
      </Route>
    </Switch>
  );
}
